import React, { useCallback } from 'react';
import { Alert, Linking } from 'react-native';

import { useLocalizationContext } from '@order/Localization';

import { ShareOption } from './ShareOption';
import type { ShareOptionProps } from './types';

export const TwitterShareOption = ({ shareLink }: ShareOptionProps) => {
  const { t } = useLocalizationContext();

  const handleShare = useCallback(async () => {
    const shareUrl = `https://twitter.com/intent/tweet?text=${t(
      'account.refer-friend.share.content',
      { shareLink },
    )}`;

    if (!(await Linking.canOpenURL(shareUrl))) {
      Alert.alert(t('general.error'));

      return;
    }

    await Linking.openURL(shareUrl);
  }, [t, shareLink]);

  return (
    <ShareOption
      testID="account.refer-friend.share.twitter"
      hint={t('account.refer-friend.share.twitter')}
      iconName="IconTwitter"
      iconSize={40}
      bgColor="#55ACEE"
      handleShare={handleShare}
    />
  );
};
